"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { AccountSessionMixins } from "@/service/account-session";
import { UiConfirm } from "@/service/ConfirmBox/confirm";
import API from "@ym-framework/api-utils";
import { Component, PropSync, Mixins } from "vue-property-decorator";
import _ from "lodash";
let BatchOpenAutoRenew = class extends Mixins(AccountSessionMixins) {
  get show() {
    for (let item of this._controller.selected) {
      if (!item.marks.is("IS_ADMIN")) {
        return false;
      }
    }
    if (this._controller.query.filter.group === "vdgroup_system_recycle") {
      return false;
    }
    return true;
  }
  autoRenew(flag) {
    return __async(this, null, function* () {
      let guids = [];
      let hastime = false;
      for (let item of this._controller.selected) {
        if (item.expire_in_seconds <= 3600 * 72) {
          hastime = true;
        }
        let datavd = {
          auto_renew: flag,
          vd_guid: item.id
        };
        guids.push(datavd);
      }
      try {
        if (flag && hastime) {
          yield UiConfirm.confirm(
            this.$t("vdcontainer.selected_tip"),
            this.$t("vdcontainer.selected"),
            {
              cancelButtonText: this.$t("vdcontainer.i_know"),
              showConfirmButton: false
            }
          );
        } else {
          const ids = _.map(guids, "vd_guid");
          yield API.post(`api://base.auth.pro/v1/virtual-desktops-auto-renew`, {
            "ids": ids
          });
          this.$message.success(
            this.$t("vdcontainer.operation_successful")
          );
        }
        yield this.$emit("refresh");
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
};
__decorateClass([
  PropSync("controller")
], BatchOpenAutoRenew.prototype, "_controller", 2);
BatchOpenAutoRenew = __decorateClass([
  Component
], BatchOpenAutoRenew);
export {
  BatchOpenAutoRenew as default
};
